import * as React from 'react';

import SvgContainer from './SvgContainer';

function SvgWarningCircle( { width, height, color = "#071956", ...remProps } ){
  return (
    <SvgContainer { ...remProps }
      width={ width }
      height={ height }
      fill="none" xmlns="http://www.w3.org/2000/svg"
    >
    <g clip-path="url(#clip0_13952_7321)">
        <path d="M8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM8 4C7.725 4 7.5 4.225 7.5 4.5V8.5C7.5 8.775 7.725 9 8 9C8.275 9 8.5 8.775 8.5 8.5V4.5C8.5 4.225 8.275 4 8 4ZM8.75 11C8.75 10.8011 8.67098 10.6103 8.53033 10.4697C8.38968 10.329 8.19891 10.25 8 10.25C7.80109 10.25 7.61032 10.329 7.46967 10.4697C7.32902 10.6103 7.25 10.8011 7.25 11C7.25 11.1989 7.32902 11.3897 7.46967 11.5303C7.61032 11.671 7.80109 11.75 8 11.75C8.19891 11.75 8.38968 11.671 8.53033 11.5303C8.67098 11.3897 8.75 11.1989 8.75 11Z" fill={color}/>
    </g>
    </SvgContainer>
  );
}

export default SvgWarningCircle;
